import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Surface
          "flex h-9 w-full rounded-md border border-zinc-800 bg-zinc-950/40 px-3 py-1",
          // Typography
          "text-sm text-zinc-100 placeholder:text-zinc-500",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          // Interaction
          "shadow-[inset_0_1px_0_rgba(255,255,255,0.02)] transition-colors",
          "hover:border-zinc-700",
          "focus-visible:border-zinc-600 focus-visible:ring-1 focus-visible:ring-zinc-600",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
